module.exports = __webpack_public_path__ + "static/media/wide.4b330855.jpg";